import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { BaasActionButton } from '../baas-action-button/baas-action-button';
import { BaasActionButtonOptions } from '../baas-action-button/baas-action-button.types';
import { _BAAS_HERO_VISUAL_BACKGROUND_MAPPINGS } from './baas-hero.const';
import { BaasHeroOptions } from './baas-hero-options';

@Component({
    selector: 'baas-hero',
    templateUrl: './baas-hero.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'baas-hero', '[class]': 'backgroundClass()' },
    imports: [NgClass, MatTooltip, MatIconButton, MatIcon, BaasActionButton]
})
export class BaasHero {
    readonly hero = input.required<BaasHeroOptions>();
    readonly close = output();

    protected readonly imageClass = computed(() => this.#camelToKebab(this.hero().visual));
    protected readonly backgroundClass = computed(() => {
        if (!this.hero().visual) return undefined;
        return _BAAS_HERO_VISUAL_BACKGROUND_MAPPINGS[this.hero().visual];
    });
    protected readonly actionButton = computed(() => {
        if (!this.hero().actionButton) return this.hero().actionButton;
        return {
            ...this.hero().actionButton,
            variant: this.hero().actionButton.variant || 'flat'
        } as BaasActionButtonOptions;
    });

    protected readonly closeable = computed(() => (this.hero().closeable === undefined ? true : this.hero().closeable));

    protected onClose(): void {
        if (this.hero().onClose) this.hero().onClose();
        this.close.emit();
    }

    #camelToKebab(str: string): string {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
}
